import { Component, inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { BusyService } from "~app/common/components/busy/busy.service";
import { SimpleSelectionItem } from "~app/common/components/selector/simple-selection-item";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { FragaForm } from "~app/features/administration/systemadministration/tabs/sysadm-checklista/sysadm-checklist-forms";
import { ChecklisteFragaAdminDTO } from "~app/features/administration/systemadministration/tabs/sysadm-checklista/sysadm.checklista.models";
import { SysdamChecklistaService } from "~app/features/administration/systemadministration/tabs/sysadm-checklista/sysdam-checklista.service";

@Component({
    selector: "rask-sysadm-edit-fraga-dialog",
    imports: [
        ReactiveFormsModule,
        RaskCommonModule
    ],
    templateUrl: "./sysadm-edit-fraga-dialog.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./sysadm-edit-fraga-dialog.component.scss"
})
export class SysadmEditFragaDialogComponent implements OnInit {
    data: ChecklisteFragaAdminDTO;
    protected fragaForm: FragaForm;
    protected selectorItems: SimpleSelectionItem[];

    private readonly fb = inject(FormBuilder);
    private readonly modal = inject(NgbActiveModal);
    private readonly busyService = inject(BusyService);
    private readonly sysdamChecklistaService = inject(SysdamChecklistaService);

    ngOnInit(): void {
        this.sysdamChecklistaService.getAllGrupperWithFragor().subscribe(grupper => {
            this.selectorItems = grupper.map(g => ({
                text: g.gruppNamn,
                value: g.id
            }));
        });

        this.fragaForm = this.fb.group({
            grupp: [
                this.data?.gruppId,
                Validators.required
            ],
            beskrivning: [
                this.data?.beskrivning,
                Validators.required
            ],
            aktiv: [this.data?.aktiv]
        });
    }

    protected onSave() {
        const fraga = this.mapFromForm();
        const work = this.sysdamChecklistaService.createChecklisteFraga(fraga);
        const response$ = this.busyService.addWork(work);
        response$.subscribe((result) =>
            this.modal.close(result));
    }

    protected canSave() {
        return !this.fragaForm.invalid;
    }

    protected onCancel() {
        this.modal.close();
    }

    private mapFromForm(): ChecklisteFragaAdminDTO {
        return {
            gruppId: this.fragaForm.get("grupp").value,
            beskrivning: this.fragaForm.get("beskrivning").value,
            id: this.data?.id,
            aktiv: this.fragaForm.get("aktiv").value
        } as ChecklisteFragaAdminDTO;
    }
}
